<template>
  <!-- 自助退费查询首页 -->
  <div class="white_bg">
    <div class="bindStudent">
      <div class="top">
        <div class="boxd">
          <img :src="logo" alt />
        </div>
        <img class="rightLogo" src="../../assets/img/slf_logo.png" alt />
      </div>
      <div class="companyname">{{ sponsor ? sponsor : "北京博思致新互联网科技有限责任公司" }}</div>
      <div class="center">
        <van-form>
          <div v-if="searchFiled.length == 0">
            <div class="fieldBox" v-for="(item, index) in defaultInfo" :key="index">
              <img v-if="item.value == 'paymentUnit'" src="../../assets/img/paymentUnit.png" alt />
              <img v-if="item.value == 'idCard'" src="../../assets/img/iconCard.png" alt />
              <img v-if="item.value == 'phone'" src="../../assets/img/wxphone.png" alt />
              <van-field
                v-model="queryInfo[item.value]"
                :name="item.label"
                :placeholder="'请输入' + item.label"
              />
            </div>
          </div>
          <div v-else>
            <template v-for="(item, index) in searchFiled">
              <div
                v-if="showRemark && item.fieldName == 'remark'"
                class="fieldBox"
                :key="item.fieldName"
              >
                <img v-if="showRemark" src="../../assets/img/remarkone.png" alt />
                <div v-if="showRemark" @click="toggleRemark" class="wrap">
                  <span v-if="showRemark">添加更多{{item.showName}}信息</span>
                  <van-icon v-if="showRemark" name="arrow-down" />
                </div>
              </div>
              <div v-if="!showRemark && item.fieldName == 'remark'" class="remarkBox" :key="index">
                <div class="boxTop">
                  <img src="../../assets/img/remarkone.png" alt />
                  <div class="remkNotice">
                    <span v-if="!showRemark">请输入{{item.showName}}信息</span>
                    <van-icon @click="toggleRemark" v-if="!showRemark" name="arrow-up" />
                  </div>
                </div>
                <div class="hr"></div>
                <div>
                  <van-field
                    v-model="queryInfo[item.fieldName]"
                    rows="4"
                    autosize
                    label
                    type="textarea"
                    maxlength="50"
                    :placeholder="'请输入'+item.showName"
                    show-word-limit
                  />
                </div>
              </div>
              <div
                v-if="item.showName != '验证码' && item.showName != '备注'"
                class="fieldBox"
                :key="index"
              >
                <img
                  v-if="item.fieldName == 'paymentUnit'"
                  src="../../assets/img/paymentUnit.png"
                  alt
                />
                <img v-else-if="item.fieldName == 'idCard'" src="../../assets/img/iconCard.png" alt />
                <img v-else-if="item.fieldName == 'phone'" src="../../assets/img/wxphone.png" alt />
                <img v-else src="../../assets/img/kzpic.png" alt />
                <van-field
                  v-model="queryInfo[item.fieldName]"
                  :name="item.showName"
                  :placeholder="'请输入' + item.showName"
                />
              </div>
              <!-- <van-field
                label-align="left"
                label-width="2.8rem"
                :key="index"
                v-model="queryInfo[item.fieldName]"
                :label="item.showName"
                label-class="formLabel"
                :placeholder="'请输入' + item.showName"
              />-->
              <div v-if="item.showName == '验证码'" class="fieldBox" :key="item.showName">
                <img src="../../assets/img/wxyzm.png" alt />
                <van-field
                  maxlength="6"
                  class="varify"
                  v-model="queryInfo[item.fieldName]"
                  name="短信验证码"
                  placeholder="请输入验证码"
                  :rules="[{ required: true, message: '' }]"
                />
                <div class="getVari">
                  <span v-if="disabledShow" @click="getVerification">获取验证码</span>
                  <span v-else>{{ timer }}s后重新获取</span>
                </div>
              </div>
              <!-- <div v-else style="position: relative" :key="item.showName">
                <van-field
                  v-if="item.showName == '验证码'"
                  label-align="left"
                  label-width="2.8rem"
                  maxlength="6"
                  :key="index"
                  v-model="queryInfo[item.fieldName]"
                  :label="item.showName"
                  label-class="formLabel"
                  :placeholder="'请输入' + item.showName"
                />
                <p v-if="disabledShow" class="getVeri" @click="getVerification">
                  获取验证码
                </p>
                <p v-else class="getVeri">{{ timer }}秒后重试</p>
              </div>-->
              <!-- v-if="item.showName == '备注'" -->
            </template>
          </div>
        </van-form>
        <div class="btn_class">
          <van-button native-type="submit" @click="toPay" class="bindBtn">
            下一步
            <img class="blueSha" src="../../assets/img/blueshadow.png" alt />
          </van-button>
        </div>
        <div class="pri">
          <van-checkbox v-model="isRead" shape="square" label-disabled>
            <span @click="isRead = !isRead">勾选即代表我已阅读并同意</span>
            <span @click="toNotice">《用户隐私政策》</span>
          </van-checkbox>
        </div>
        <!-- :key="new Date().getTime()" -->
        <CustomFoot
          :typeName="'16'"
          :isHome="isHomeFlag"
          class="zdyfooter"
          color="#297bf4"
          state="2"
        >
          <div class="btn_shadow notice_box_foot">
            确认
            <span></span>
          </div>
        </CustomFoot>
        <!-- <Foot
          v-if="list && list.bottomMessage && list.bottomMessage.length > 0"
          :list="list"
        ></Foot>-->
        <!-- <div v-if="list && list.bottomMessage && list.bottomMessage.length > 0" class="footer">
          <div v-html="item" v-for="(item,index) in list.bottomMessage" :key="index" class="notice-item" style=""></div>
          <div class="foot">
            <div v-for="(item,index) in list.supplier" :key="index" class="foot-item">{{item}}</div>
          </div>
        </div>-->
        <!-- <van-dialog v-model="showDialog" title="提示">
        <div class="notice">{{ notice }}</div>
        </van-dialog>-->
      </div>
      <ErrorNotice @close="showErr = false" :show="showErr" :notice="notice"></ErrorNotice>
    </div>
  </div>
</template>

<script>
import Head from "@/components/head"
import Foot from "@/components/foot"
import { Dialog, Toast } from "vant"
import { judgeVde } from "@/utils/publicJudge"
import { publicEncrypt, privateDecrypt } from "@/utils/common"
import PrivacyDialog from "@/components/dialog/privacyDialog"
import { handleTrim } from "../../utils/common"
import ErrorNotice from "@/components/dialog/errorNotice"
import CustomFoot from "@/components/customFoot"

let Base64 = require("js-base64").Base64
export default {
  name: "RefundQuery",
  components: {
    Head,
    Foot,
    PrivacyDialog,
    ErrorNotice,
    CustomFoot
  },
  data() {
    return {
      showErr: false,
      activeNames: ["1"],
      queryInfo: {
        idCard: "",
        paymentUnit: "",
        phone: ""
      },
      defaultInfo: [
        { label: "证件号码", value: "idCard" },
        { label: "手机号码", value: "phone" },
        { label: "姓名", value: "paymentUnit" }
      ],
      showDialog: false,
      notice: "",
      logo: "",
      sponsor: "",
      vde: "",
      type: 0,
      list: [],
      // 小程序的参数
      openid: "",
      isWxmp: false, //判断是否在小程序内
      mpData: {},
      h5QueryCondition: "", //查询条件
      searchFiled: [],
      isHomeFlag: false,
      isRead: false,
      details: [],
      showD: false,
      appId: "",
      queryDa: [], // 微信查询条件集合
      curData: {}, // 查询中间数据
      timer: 60,
      disabledShow: true,
      isVerifyCode: false,
      showRemark: true,
      s: ""
    }
  },
  created() {
    this.vde = this.$route.query.vde ? this.$route.query.vde : ""
    this.s = this.$route.query.s ? this.$route.query.s : ""
    this.isHomeFlag = true
    // if (this.s) {
    //   let queryInfo = JSON.parse(this.$route.query.s)
    //   this.vde = queryInfo.vde
    // } else {
    //   this.isHomeFlag = false
    // }
    //判断vde
    this.initFrom()
    judgeVde({ vde: this.vde }, this)
    this.getHeadImg()
    this.getFootData()
    window.localStorage.removeItem("searchInfo")
    // localStorage.removeItem("isWxCCode")   //调试时使用
    // let isWx = this.isWx()
    // if (isWx) {
    //   //在微信中打开
    //   if (
    //     localStorage.getItem(this.vde + "opendID") == "" ||
    //     localStorage.getItem(this.vde + "opendID") == "null"
    //   ) {
    //     localStorage.removeItem(this.vde + "opendID")
    //   }
    //   let isWxCode = this.$route.query?.code
    //   let vde = localStorage.getItem("vde")
    //   let url = window.location.href
    //   debugger
    //   // if (isWxCode) {
    //   //   this.isHomeFlag = true
    //   //   if (
    //   //     localStorage.getItem(this.vde + "opendID") &&
    //   //     localStorage.getItem(this.vde + "opendID") != "" &&
    //   //     localStorage.getItem(this.vde + "opendID") != "null"
    //   //   ) {
    //   //     this.openid = localStorage.getItem(this.vde + "opendID")
    //   //     this.getWxQuery()
    //   //   } else {
    //   //     //重定向后的地址
    //   //     this.getOpenIdByCode({ code: isWxCode, vde: vde })
    //   //   }
    //   //   this.$forceUpdate()
    //   // } else {
    //   //   this.isHomeFlag = false
    //   //   //没有code参数 为第一次进入
    //   //   this.getWxAuthorizeUrl({ redirectUri: url, deptId: vde })
    //   // }
    //   // if (localStorage.getItem(this.vde + "opendID")) {
    //   //   this.openid = localStorage.getItem(this.vde + "opendID")
    //   // }
    // } else {
    //   this.openid = ""
    //   this.isHomeFlag = true
    // }
  },
  mounted() {
    this.getSearchFiled()
  },
  activated() {
    let { isRead } = this.$route.query
    this.isRead = isRead == 1 ? true : false
    if (this.isRead) {
      this.toPay()
    }
    // this.getSearchFiled()
  },
  methods: {
    toNotice() {
      this.$router.push({
        path: "/refund/payNotice",
        query: {
          person: "1",
          headerText: "通知"
        }
      })
    },
    // 切换备注
    toggleRemark() {
      this.showRemark = !this.showRemark
    },
    getVerification() {
      let reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (this.queryInfo.phone.length) {
        if (reg.test(this.queryInfo.phone)) {
          let obj = {
            vde: this.vde,
            type: "2",
            name: this.queryInfo.paymentUnit,
            phone: this.queryInfo.phone,
            idCard: this.queryInfo.idCard
          }
          this.request({
            baseURL: process.env.VUE_APP_PAY_URL,
            url: `/sms/sendVerifiCodeQuery`,
            method: "post",
            data: obj
          }).then((res) => {
            // console.log(res)
            if (res.data.code == 1000) {
              Toast({ message: res.data.message, icon: "none" })
              //
              this.disabledShow = false
              const authTimer = setInterval(() => {
                this.timer--
                if (this.timer <= 0) {
                  this.disabledShow = true
                  this.timer = 60
                  clearInterval(authTimer)
                }
              }, 1000)
            } else {
              this.disabledShow = true
              Toast({ message: res.data.message, icon: "none" })
            }
          })
        } else {
          Toast({ message: "手机号码格式不正确", icon: "none" })
        }
      } else {
        Toast({ message: "手机号码不能为空", icon: "none" })
      }
    },
    getWxAuthorizeUrl(obj) {
      let { deptId } = obj
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: `/wx/getWxAuthorizeUrl?deptId=${deptId}&redirectUri=${encodeURIComponent(
          `/`
        )}&type=01`,
        method: "post"
      }).then((res) => {
        // console.log(res.data.message)
        if (res.data.code === 1000) {
          window.location = res.data.result.authorizeUrl
          localStorage.setItem("appId", res.data.result.appId)
        } else {
          this.isHomeFlag = true
        }
      })
    },
    getOpenIdByCode(obj) {
      let { code, vde } = obj
      let appid = localStorage.getItem("appId")
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: `/wx/getOpenIdByAppId?code=${code}&appId=${appid}`,
        method: "post"
      }).then((res) => {
        if (res.data.code === 1000) {
          // let obj = {
          //   vde: this.$route.query.vde,
          //   opendID: res.data.result
          // }
          // alert(res.data.result);
          this.openid = res.data.result
          //成功后保存到浏览器缓存
          localStorage.setItem(this.vde + "opendID", res.data.result)
          // 获取微信推送条件
          this.getWxQuery()
        }
      })
    },
    getWxQuery() {
      let arrId = localStorage.getItem("appId")
      this.request({
        url: "/mobile/queryWxData",
        method: "get",
        params: {
          wxOpenId: this.openid,
          vde: this.vde,
          arrId
        }
      }).then((res) => {
        // alert(res.data.result);
        if (res.data.code === 1000) {
          this.queryDa = res.data.result
          let { source } = this.$route.query
          if (source == "other") {
            let state = this.$route.query
            let arr = Object.keys(this.queryInfo)
            arr.map((item) => {
              this.queryInfo[item] = state[item]
            })
          } else {
            if (this.queryDa.length > 0) {
              this.queryDa.forEach((item) => {
                this.queryInfo[item.fieldName] = item.fieldValueShow
              })
            }
          }
        }
      })
    },
    isWx() {
      return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1 //通用
    },
    closeO() {
      this.showD = false
    },
    // 小程序来源初始化地址
    initFrom() {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            this.isWxmp = true
            let arr = window.location.pathname.split("/")
            let str = arr[arr.length - 1]
            this.mpData = JSON.parse(Base64.decode(Base64.decode(str)))
            this.openid = this.$route.query.openid
              ? this.$route.query.openid
              : ""
            if (this.openid == "") {
              this.openid = this.$route.query.openId
                ? this.$route.query.openId
                : ""
            }
            this.mpData.params.split("&").forEach((item) => {
              if (item.split("=")[0] == "vde") {
                this.vde = item.split("=")[1]
              }
            })
            window.localStorage.setItem("wxmpBack", "")
          } else {
          }
        })
      }
    },
    getReadState(isRead, details, type) {
      this.isRead = isRead
      this.details = details
    },
    goNextAction(isRead, details, type) {
      this.isRead = isRead
      this.details = details
      if (type == 1) {
        this.toPay()
      }
    },
    // 获取搜索条件
    getSearchFiled() {
      this.request({
        url: "/busEduConfig/listH5BusEduQuery",
        method: "get",
        params: { vde: this.vde }
      }).then((res) => {
        if (res.data.code == 1000) {
          this.searchFiled = res.data.result ? res.data.result : []
          this.searchFiled.forEach((item) => {
            if (item.fieldName == "verifyCode" && item.showName === "验证码") {
              this.isVerifyCode = true
            }
            this.$set(this.queryInfo, item.fieldName, "")
          })
          let remarkObj = null
          this.searchFiled.forEach((item, index) => {
            if (item.fieldName == "remark" && item.showName === "备注") {
              // this.searchFiled.push(item);
              remarkObj = item
              this.searchFiled.splice(index, 1)
            }
          })
          if (remarkObj) {
            this.searchFiled.push(remarkObj)
          }
          let state = this.$route.query
          let arr = Object.keys(this.queryInfo)
          arr.map((item) => {
            this.queryInfo[item] = state[item]
          })
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.message
          }).then(() => {})
        }
      })
    },
    getHeadImg() {
      let data = {}
      data.vde = this.vde
      this.request({
        url: "/webPortal/websitConfig",
        method: "get",
        params: data
      }).then((res) => {
        if (res.data.code == 1000) {
          if (res.data.result == null) {
            this.logo = require("@/assets/img/logo.png")
            return
          }
          if (res.data.result.logoUrl) {
            this.logo = res.data.result.logoUrl
          } else {
            this.logo = require("@/assets/img/logo.png")
          }
          if (res.data.result && res.data.result.websitTitle) {
            document.title = res.data.result.websitTitle
            sessionStorage.setItem("title", res.data.result.websitTitle)
          } else {
            document.title = "欢迎使用政付通缴费平台"
          }
          if (res.data.result.logoName) {
            this.sponsor = res.data.result.logoName
          }
          this.h5QueryCondition = res.data.result.h5QueryCondition
          if (this.h5QueryCondition == null) {
            this.isShowId = true
            this.isShowPhone = true
            this.isShowName = true
            return
          }
          this.isShowId = this.h5QueryCondition.includes("idCard")
          this.isShowPhone = this.h5QueryCondition.includes("phone")
          this.isShowName = this.h5QueryCondition.includes("paymentUnit")
        } else if (res.data.code != 1000) {
          this.$router.push({ path: "/404" })
        }
      })
    },
    // 获取底部数据
    getFootData() {
      let data = {
        vde: this.vde,
        type: 16
      }
      this.request({
        url: "/systemManage/mobileGetMessage",
        method: "get",
        params: data
      }).then((res) => {
        if ((res.data.code = 1000)) {
          this.list = res.data.result
        }
      })
    },
    toPay() {
      if (!this.isVerifyCode) {
        this.queryInfo = handleTrim(this.queryInfo)
        var arr = Object.values(this.queryInfo).filter((item) => {
          if (item !== "" && item) {
            return true //过滤掉为空的项
          }
        })

        // 判断当前条件是否被修改过
        this.curData = JSON.parse(JSON.stringify(this.queryInfo))
        this.queryDa.forEach((item) => {
          if (item.fieldValueShow == this.queryInfo[item.fieldName]) {
            this.curData[item.fieldName] = item.fieldValue
          }
        })

        // curData  this.queryInfo
        if (arr.length == 0) {
          // this.showDialog = true;
          // this.notice = "至少输入一个查询条件"
          // this.showErr = true

              this.$CDialog({
                confirmBtnText: '确认',
                title: "提示",
                status: "2",
                message: '至少输入一个查询条件'
              });
        } else if (
          this.curData.phone &&
          !/^1\d{10}$/.test(this.curData.phone)
        ) {
          // this.showDialog = true;
          // this.showErr = true
          // this.notice = "手机号码格式不正确"
          this.$CDialog({
                confirmBtnText: '确认',
                title: "提示",
                status: "2",
                message: '手机号码格式不正确'
              });
        } else {
          // 检验是否勾选了隐私协议
          if (this.isRead == false) {
            // this.$refs.privacyDialog.open();
            this.$router.push({
              path: "/refund/payNotice",
              query: {
                person: "1",
                headerText: "通知"
              }
            })
            // console.log(111);
            return
          }
          if (
            this.searchFiled.length == 1 &&
            this.searchFiled[0].fieldName == "paymentUnit"
          ) {
            // this.notice =
            //   "注意：当前只配置了“缴款单位/人”查询，查询结果可能重复，建议您可多配置1个查询条件"
            // this.showErr = true
            this.$CDialog({
                confirmBtnText: '确认',
                title: "提示",
                status: "2",
                message: '注意：当前只配置了“缴款单位/人”查询，查询结果可能重复，建议您可多配置1个查询条件'
              });
            // Dialog.alert({
            //   title: "提示",
            //   message:
            //     "注意：当前只配置了“缴款单位/人”查询，查询结果可能重复，建议您可多配置1个查询条件",
            // }).then(() => {
            //   this.jump();
            // });
          } else if (this.queryInfo.paymentUnit && arr.length == 1) {
            // Dialog.alert({
            //   title: "提示",
            //   message:
            //     "您只输入了缴款人“缴款单位/人”查询，防止查询结果错误，请再输入一个查询条件",
            // }).then(() => {});
            // this.showErr = true
            // this.notice =
            //   "您只输入了缴款人“缴款单位/人”查询，防止查询结果错误，请再输入一个查询条件"
              this.$CDialog({
                confirmBtnText: '确认',
                title: "提示",
                status: "2",
                message: '您只输入了缴款人“缴款单位/人”查询，防止查询结果错误，请再输入一个查询条件'
              });
            return
          } else {
            this.jump()
          }
        }
      } else {
        // 检验是否勾选了隐私协议
        if (this.isRead == false) {
          // this.$refs.privacyDialog.open();
          this.$router.push({
            path: "/refund/payNotice",
            query: {
              person: "1",
              headerText: "通知"
            }
          })
          return
        }
        if (this.queryInfo.phone && this.queryInfo.verifyCode) {
          let reg =
            /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
          if (!reg.test(this.queryInfo.phone)) {
            // Toast({ message: "手机号码格式不正确", icon: "none" });
            // this.showErr = true
            // this.notice = "手机号码格式不正确"
            this.$CDialog({
                confirmBtnText: '确认',
                title: "提示",
                status: "2",
                message: '手机号码格式不正确'
              });
            return
          }
          let obj = {
            type: "2",
            vde: this.vde,
            ...this.queryInfo
          }
          this.request({
            baseURL: process.env.VUE_APP_PAY_URL,
            url: "/sms/confirmVerifiCode",
            method: "post",
            data: obj
          }).then((res) => {
            if (res.data.code == 1000) {
              this.curData = obj
              this.jump()
            } else {
              Toast({ message: res.data.message, icon: "none" })
            }
          })
        } else {
          // !/^1\d{10}$/.test(this.curData.phone)
          if (!this.queryInfo.phone) {
            // this.showErr = true
            // this.notice = "手机号码不能为空"
            this.$CDialog({
                confirmBtnText: '确认',
                title: "提示",
                status: "2",
                message: '手机号码不能为空'
              });
            // Toast({ message: "手机号码不能为空", icon: "none" });
            return
          }
          if (!this.queryInfo.verifyCode) {
            // this.showErr = true
            // this.notice = "验证码不能为空"
            this.$CDialog({
                confirmBtnText: '确认',
                title: "提示",
                status: "2",
                message: '验证码不能为空'
              });
            // Toast({ message: "验证码不能为空", icon: "none" });
            return
          }
        }
      }
    },
    jump() {
      // 非小程序带的参数
      // this.queryInfo.fromtype = 1
      this.curData.fromtype = 1
      sessionStorage.setItem("privacyDetailsH5", JSON.stringify(this.details))
      if (this.isWxmp == false) {
        let obj = {
          ...this.curData,
          wxOpenId: this.openid
        }
        // console.log(this.curData);
        let str = JSON.stringify(obj)
        let s = publicEncrypt(str)
        window.localStorage.setItem("searchInfo", str)
        this.$router.push({
          path: "/refund/result?vde=" + this.vde + "&s=" + s
        })
      } else if (this.isWxmp == true) {
        // this.queryInfo.openid = this.openid

        // this.queryInfo.userId = this.mpData.userId
        // this.queryInfo.paymentName = this.mpData.paymentName
        this.curData.openid = this.openid
        this.curData.userId = this.mpData.userId
        this.curData.paymentName = this.mpData.paymentName
        let str = JSON.stringify(this.curData)

        window.localStorage.setItem("searchInfo", str)
        let s = publicEncrypt(str)
        this.$router.push({
          path: "/refund/result?vde=" + this.vde + "&s=" + s
        })
        // console.log(this.queryInfo)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.white_bg {
  background: #fff;
  min-height: 100vh;
}
.bindStudent {
  background: url("../../assets/img/backi.png") no-repeat;
  background-size: 100%;
  .companyname {
    ;
    font-size: 20px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 700;
    text-align: left;
    padding-left: 26px;
  }
  .top {
    height: 156px;
    display: flex;
    align-items: flex-end;
    .boxd {
      width: 80px;
      height: 80px;
      background: #fff;
      border-radius: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 26px;
      margin-bottom: 20px;
      //todo logo
      > img {
        width: 79px;
      }
    }
    .rightLogo {
      display: block;
      width: 172px;
      height: 150px;
      margin: 0px auto;
      margin-right: 20px;
    }
  }

  .center {
    margin-top: 7px;
    background: url("../../assets/img/blcard.png") no-repeat;
    background-size: 100%;
    padding-top: 18px;
    .remarkBox {
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      height: 212px;
      width: 325px;
      margin: 14px auto;
      .boxTop {
        padding: 5px 10px;
        padding-top: 0px;
        display: flex;
        align-items: center;
        > img {
          width: 56px;
          height: 56px;
          margin-left: -10px;
        }
        .remkNotice {
          width: 255px;
          // margin-left: 16px;
          margin-bottom: 10px;

          font-size: 16px;
          color: #464a4c;
          letter-spacing: 0;
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          padding-right: 10px;
        }
      }
      .hr {
        width: 285px;
        margin: 0 auto;
        height: 1px;
        background: #f0f0f0;
        padding-left: 10px;
        padding-right: 10px;
        margin-top: -12px;
      }
      ::v-deep .van-field__control::-webkit-input-placeholder {

        font-size: 16px;
        color: rgba(70, 74, 76, 0.7);
        letter-spacing: 0;
        font-weight: 500;
      }
    }
    .fieldBox {
      ::v-deep .van-cell {
        padding-left: 0px;
      }
      ::v-deep input.van-field__control::-webkit-input-placeholder {

        font-size: 16px;
        color: rgba(70, 74, 76, 0.7);
        letter-spacing: 0;
        font-weight: 500;
      }
      margin: 12px auto;
      background: #fff;
      border-radius: 25px;
      width: 325px;
      height: 44px;
      display: flex;

      .wrap {

        font-size: 16px;
        color: #464a4c;
        letter-spacing: 0;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
        padding: 0px 20px;
        padding-left: 16px;
        padding-left: 0px;
      }
      .wrapF {
        width: 325px;
        height: 212px;
        background: #fff;
        .wrap {

          font-size: 16px;
          color: #464a4c;
          letter-spacing: 0;
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          width: 100%;
          align-items: center;
          padding: 0px 20px;
        }
      }
      img {
        width: 56px;
        height: 56px;
      }

      ::v-deep .van-field {
        width: 240px !important;
      }

      .varify {
        width: 150px !important;
      }

      .getVari {

        font-size: 16px;
        color: #208fff;
        letter-spacing: 0;
        font-weight: 500;
        line-height: 44px;
        margin-left: 0px;
      }
    }
  }

  ::v-deep .footNotice {
    padding: 0px 20px;
  }

  ::v-deep .foot {
    margin-bottom: 0px !important;
  }
}
.btn_class{
  margin-top: 20px;
  margin-bottom: 23px;
  margin-left: 22px;

}
.bindBtn {
  background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
  width: 325px;
  height: 50px;
  border-radius: 27px;
  font-size: 20px;
  color: #fff;
  font-weight: 700;

  color: #ffffff;
  letter-spacing: 0;
  font-weight: 700;
  position: relative;
  .blueSha {
    width: 286px;
    height: 34px;
    position: absolute;
    left: 50%;
    top: 68%;
    transform: translateX(-50%);
  }
}

.pri {
  // margin:0 auto;
  // text-align: center;
  display: flex;
  align-items: center;
  // justify-content: center;
  margin-left:23px;
  // padding-left: 12px;
  span:nth-of-type(1) {

    font-size: 14px;
    color: #464a4c;
    letter-spacing: 0;
    line-height: 12px;
    font-weight: 400;
  }
  span:nth-of-type(2) {

    font-size: 14px;
    color: #208fff;
    letter-spacing: 0;
    line-height: 12px;
    font-weight: 700;
  }
  ::v-deep .van-checkbox__icon .van-icon {
    border-radius: 4px;
    border-color: #208fff;
  }
}

.footer {
  padding: 0px 27px;
  margin-top: 30px;
  font-size: 12px;
  font-family: PingFang SC;
  color: #666;
  line-height: 22px;
  text-align: left;
  box-sizing: border-box;
  .foot {
    padding: 25px 0;
    width: 100%;
    box-sizing: border-box;
    .foot-item {
      width: 100%;
      text-align: center;
      font-size: 11px;
      font-family: PingFang SC;
      color: #333;
      font-weight: bold;
    }
  }
}

.zdyfooter {
  padding: 0px 28px;
  margin-top: 30px;
}
.notice_box_foot {
  background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
  border-radius: 22px;
  margin: 0 19px;
  height: 46px;
  line-height: 46px;

  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
}
.btn_shadow,
.notice_box_foot {
  position: relative;
  > span {
    position: absolute;
    width: 90%;
    background: url("../../assets/img/blueshadow.png") 0 0 no-repeat;
    background-size: 100% 100%;
    border-radius: 0.58667rem;
    height: 0.96rem;
    left: 50%;
    margin-left: -45%;
    bottom: -19px;
    z-index: 0;
  }
}
</style>
